import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';

export class LiabilityUsageType extends Enum {
  static FAMILY = {
    key: 'family',
    get value() {
      return Lang.t('asset.family');
    }
  };

  static PERSONAL = {
    key: 'personal',
    get value() {
      return Lang.t('asset.personal');
    }
  };

  static WORK = {
    key: 'work',
    get value() {
      return Lang.t('asset.work');
    }
  };
}
